module.exports = __webpack_public_path__ + "img/running-shoe.c9cb43eb.png";